export const URL_CREATE_NEW_GROUP = '/groups';
export const URL_GET_ALL_GROUPS = '/groups';
export const URL_GET_GROUP_BY_ID = '/groups/:id';
export const URL_UPDATE_GROUP_BY_ID = '/groups/:id';
export const URL_DELETE_GROUP_BY_ID = '/groups/:id';
export const URL_GET_ALL_MY_MEMBERSHIPS = '/groups/my/memberships';
export const URL_CREATE_GROUP_PROJECT = '/groups/projects';
export const URL_GET_ALL_GROUP_PROJECTS = '/groups/:id/projects';
export const URL_GET_ALL_MEMBERS_GROUP = '/groups/:id/members';
export const URL_PUT_NEW_MEMBER_GROUP = '/groups/members';
export const URL_DELETE_GROUP_MEMBER = '/groups/:group_id/members/:member_id';
export const URL_UPDATE_GROUP_MEMBER = '/groups/:group_id/members';
export const URL_GET_SEARCH_DATA = '/groups/autocomplete/:id';
